
import {NgModule,Component, OnInit } from '@angular/core';
import {TimelineComponent} from '../timeline/timeline.component'
import { IonicModule } from '@ionic/angular'; 

@NgModule({
    declarations:[TimelineComponent],
    exports:[TimelineComponent],
    imports: [IonicModule],
})

export class MiscomponentesModule{

}

